import './_navigation-search-mobile.scss';

export default () => {};
